import React from 'react';
import './MoneyInput.css';

const MoneyInput = ({ value = 0, index = 0, propertyToSetValue = "", showAddon = true, readOnly = false, justTextForReadOnly = false, icon = "fas fa-dollar-sign", countryLocale = 'es-CO', styleCurrency = 'currency', currency = 'COP', showDecimal = true, numberDecimalDigits = 2, handlerChangeMoney = null }) => {
    let formatter = new Intl.NumberFormat(countryLocale, {
        style: styleCurrency,
        currency: currency,
        minimumFractionDigits: showDecimal ? numberDecimalDigits : 0
    })
    return (
        <div className="MoneyInputContainer">
            {
                showAddon ?
                <div className="addon"><i className={icon}></i></div>
                :
                ""
            }
            <div className="Input">
                <input type="number"
                onBlur={(e)=>{
                    e.currentTarget.parentNode.querySelector('input[type="text"]').style.display = "block";
                    e.currentTarget.style.display = "none"
                }}
                onKeyUp={(e)=>{
                    if (e.key === "Enter") {
                        e.currentTarget.parentNode.querySelector('input[type="text"]').style.display = "block";
                        e.currentTarget.style.display = "none"
                    }
                }}
                style={{display: "none"}} value={value} onChange={(e) => { if(handlerChangeMoney !== null) handlerChangeMoney(e.currentTarget.value, propertyToSetValue, index) }} />
                {
                    justTextForReadOnly ?
                    <p>{formatter.format(value)}</p>
                    :
                    <input type="text"
                    onFocus={(e)=>{
                        if(!readOnly){
                            let elementNumber = e.currentTarget.parentNode.querySelector('input[type="number"]');
                            elementNumber.style.display = "block";
                            elementNumber.focus();
                            e.currentTarget.style.display = "none"
                        }
                    }}
                    value={formatter.format(value)} />
                }
            </div>
        </div>
    );
}
export default MoneyInput;